import { Button, ListPageLayout } from "../../components";
import { professoresApi } from "../../services";
import { useNavigate } from "react-router-dom";

export default function Professores() {
  const navigate = useNavigate();

  return (
    <ListPageLayout
      title="Professores"
      creation={{ url: "/professores/cadastro" }}
      edition={{ url: "/professores/cadastro" }}
      deletion={{ handler: professoresApi.destroy }}
      actions={
        <Button
          className="mr-3"
          onClick={() => navigate("/professores/contratos")}
        >
          Tabela Pagamento
        </Button>
      }
      table={{
        loader: (query) => professoresApi.all({ ...query, order: ['nome,ASC', 'id,DESC']}),
        columns: [
          { title: "Id", field: "id" },
          { title: "Nome", field: "nome" },
          { title: "CNPJ", field: "cnpj" },
        ],
      }}
    />
  );
}
